import { MdOutlineAdd } from 'react-icons/md';
import { IoMdTrash } from 'react-icons/io';

type Props = {
  isSelected: boolean;
};

const ToggleTierButton = ({ isSelected }: Props) => (
  <div className="bg-black text-white rounded-3xl flex align-center justify-center h-[30px] w-[30px]">
    {isSelected ? <IoMdTrash size={20} /> : <MdOutlineAdd size={24} />}
  </div>
);
export default ToggleTierButton;
